// 任务列表路由
const lifeNec = r => require.ensure(
  [],
  () => r(require('@/components/life/nec.vue')),
  'lifeNec'
)

export default [
  // 任务列表
  {
    path: '/life/nec',
    name: 'lifeNec',
    component: lifeNec
  }
]



// WEBPACK FOOTER //
// ./src/router/sub-route/life.js